import FaceRecorder from './FaceRecorder';

export default FaceRecorder;
